import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrl: './maps.component.scss'
})

export class MapsComponent {
  @Input() order_location!: string;
  center: google.maps.LatLngLiteral = { lat: 30.0444, lng: 31.2357 }; // القاهرة كبداية
  markerPosition: google.maps.LatLngLiteral | null = null;
  markerOptions: google.maps.MarkerOptions = {
    draggable: true,
    icon: {
      url: 'assets/e-commerce/icons/54.webp', // ضع مسار الصورة هنا
      scaledSize: new google.maps.Size(50, 50), // حجم الأيقونة
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 50) // تثبيت الماركر من الأسفل
    }
  };

  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,   // ❌ يشيل كل الأزرار
    draggable: false,         // ❌ يمنع تحريك الخريطة بالماوس/التاتش
    scrollwheel: false,       // ❌ يمنع الزووم بعجلة الماوس
    disableDoubleClickZoom: true, // ❌ يمنع الزووم بالضغط مرتين
    gestureHandling: 'none',  // ❌ يمنع أي إيماءات (سحب/تكبير/تصغير)

    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    styles: [
      { elementType: 'geometry', stylers: [{ color: '#f1f3f6' }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#2a4da2' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#f1f3f6' }] },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }]
      },
      //80bdeb 004991 f0d7ab
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#f0d7ab' }]
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#dadada' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#80bdeb' }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#80bdeb' }]
      }
    ]
  };
  ngOnInit() {
    if (this.order_location) {
      this.setLocationFromLink(this.order_location);
    }
  }
  setLocationFromLink(link: string) {
    try {
      // الرابط بيبقى كده: https://www.google.com/maps?q=30.04248,31.36533
      const url = new URL(link);
      const coords = url.searchParams.get("q"); // 30.04248,31.36533

      if (coords) {
        const [lat, lng] = coords.split(",").map(Number);

        this.center = { lat, lng };
        this.markerPosition = { lat, lng };
      }
    } catch (error) {
      console.error("❌ الرابط غير صالح:", link);
    }
  }
}
